<!-- TODO: [name]="name" binding not working -->
<ngx-spinner [bdColor]="bdColor" size="medium" [color]="color" type="ball-scale-ripple-multiple"
    [fullScreen]="fullScreen">
    <p style="color: white"> {{message}} </p>
</ngx-spinner>